module.exports = __webpack_public_path__ + "static/media/red_rectangle.e600af46.svg";